// import React from 'react';
// import ReactDOM from 'react-dom';
// import './index.css';
// import App from './App';
// import * as serviceWorker from './serviceWorker';
// import { BrowserRouter } from "react-router-dom"
// import { CookiesProvider } from 'react-cookie';

// ReactDOM.render(
//     <React.Fragment>
//         <CookiesProvider>
//             <BrowserRouter>
//                 <App />
//             </BrowserRouter>
//         </CookiesProvider>
//     </React.Fragment>
//     , document.getElementById('root'));

// serviceWorker.unregister();


import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from "react-router-dom";
import { CookiesProvider } from 'react-cookie';

// ✅ Import ThemeProvider from @mui/styles
import { ThemeProvider } from '@mui/styles';
// ✅ Import createTheme from @mui/material/styles
import { createTheme } from '@mui/material/styles';
import { NotificationProvider } from './components/NotificationProvider';

const theme = createTheme(); // you can customize this theme later if needed

ReactDOM.render(
  <React.Fragment>
    <CookiesProvider>
      <BrowserRouter>
        <ThemeProvider theme={theme}> {/* ✅ Wrap ThemeProvider */}
          <NotificationProvider>
          <App />
          </NotificationProvider>
        </ThemeProvider>
      </BrowserRouter>
    </CookiesProvider>
  </React.Fragment>,
  document.getElementById('root')
);

serviceWorker.unregister();
